/**
 * @file index.tsx
 * @module app/modules/platform-fees/index
 * @description Implements the index workflow for platform-fee management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_admin/layout/core";

import PlatformFees from "./platform-fees";
const platfrmFeesBreadCrumbs: Array<PageLink> = [
  {
    title: "Platform Fees",
    path: "/platform-fees",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="*" element={<Navigate to="/error/404" />} />

        <Route index element={<Navigate to="/platform-fees/fees" />} />

        <Route
          path="fees"
          element={
            <>
              <PageTitle>
                Platform Fees
              </PageTitle>
              <PlatformFees />
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default index;
